import authModule from "../../../../utilities/AuthModule";
import { ComponentTypes } from "../../config/config";
import { IDocumentSetCreationData } from "../../interfaces/IDocumentSetCreationData";
import { IPageSettings } from "../../interfaces/IPageSettings";
import { apiCreateDocumentSet } from "../../services/ApiService";
import { createChildFolder, createRootDriveFolder, createRootSharepointDriveFolder } from "../../services/GraphService";

export const createFolder = async (currentDirectory: IPageSettings, newFolderName: string) => {
    const accessToken = await authModule.getGraphAccessToken();
    !currentDirectory.parentId
        ? await createRootFolder(accessToken, currentDirectory, newFolderName)
        : await createChildFolder(
            accessToken,
            { id: currentDirectory.id, driveId: currentDirectory.parentId },
            newFolderName
        );
};

const createRootFolder = async (accessToken: string, currentDirectory: IPageSettings, newFolderName: string) => {
    currentDirectory.type === ComponentTypes.SharePointFolders
        ? await createRootSharepointDriveFolder(accessToken, currentDirectory.id, currentDirectory.siteId, newFolderName)
        : await createRootDriveFolder(accessToken, newFolderName);
};

export const createDocumentSet = async (documentSetCreationData: IDocumentSetCreationData): Promise<void> => {
    await apiCreateDocumentSet(documentSetCreationData);
}